import ObjectHelper from "src/util/objectHelper";
import axios from "axios";

export default {
  data() {
    return {
      refresh: false,
      base: document.location.protocol + "//" + process.env.VUE_APP_API_HOST,
    };
  },
  created() {
    // this.needRefreshApp()
  },
  updated() {
    // this.needRefreshApp()
  },
  methods: {
    needRefreshApp() {
      axios.get(`${this.base}/api/verify_app_version/${process.env.VUE_APP_LAST_VERSION}`, {})
        .then((request) => {
          this.refresh = request.data.need_refresh_app
        })
    },
    updatePage() {
      window.location.href = window.location.href
    }
  }
};
